import vars from '../global/vars.js';
import initLoadIn from '../utilities/load-in';

function loadMore(loadMoreBtn, target, loader, popState = false) {
    const totalPages = loadMoreBtn.dataset.total;
    const loadUrl = loadMoreBtn.href;
    const loadType = loadMoreBtn.dataset.type;

    let nextURL;
    let nextPage = loadMoreBtn.dataset.next;

    if (nextPage <= totalPages) {
        vars.body.classList.add('working');
        loader.classList.add('show');
        loadMoreBtn.classList.add('hide');

        // Only update histroy if exists and not fired by popState
        if (history.pushState && !popState) {
            history.pushState({}, '', loadUrl);
        }

        // Get cards
        fetch(loadUrl).then((response) => response.text()).then((html) => {
            // Convert the HTML string into a document object
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Get the image file
            const cards = doc.querySelectorAll('.js-card');

            if (cards && cards.length > 0) {
                cards.forEach((card) => {
                    target.appendChild(card);
                });

                initLoadIn(cards);
            }

            nextPage++;
            loadMoreBtn.dataset.next = nextPage;

            nextURL = `${vars.site}/${loadType}/page/${nextPage}`;

            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            const userContinent = localStorage.getItem('userContinent');

            // Update next button url if apOrder set
            if (params.has('apOrder') && userContinent && (userContinent === 'AS' || userContinent === 'OC')) {
                nextURL = `${vars.site}/${loadType}/page/${nextPage}/?apOrder`;
            }

            loadMoreBtn.href = nextURL;

            if (nextPage > totalPages) {
                loadMoreBtn.setAttribute('disabled', true);
                loadMoreBtn.href = '#';
            }

            vars.body.classList.remove('working');
            loader.classList.remove('show');
            loadMoreBtn.classList.remove('hide');
        }).catch((err) => {
            // There was an error
            console.warn('Something went wrong.', err);
        });
    }
}

const initloadMore = (loreMoreDiv, loadMoreBtn) => {
    // Setup load more listener
    if (loadMoreBtn) {
        const loader = document.querySelector('.js-loader');

        document.addEventListener('click', (event) => {
            if (event.target === loadMoreBtn) {
                event.preventDefault();
                loadMore(loadMoreBtn, loreMoreDiv, loader);
            }
        });
    }
};

export { initloadMore as default };
